import Show from './Show.js';
import {useEffect, useRef, useState} from 'react';
import SelectedShow from  './SelectedShow.js'
import Popup from './Popup.js';

function FullDaySchedule(props)
{

    const selectedShowForFullDay = useRef(null);
    const [selectedShow, setSelectedShow] = useState({});
    const [selectedDay, setSelectedDay] =useState(props.activeDate.day);
    const [showPopup, setShowPopup] = useState(false);
    let [listDayShows, setListDayShows] = useState(Array());
    let [message, setMessage] = useState("");
    const currentDate = new Date();


    useEffect(()=>{
        console.log("Date chnagfes to " + props.activeDate.day) 
        setSelectedShow({});
        setListDayShows(getlistDayShows());
       
        
    },[props.activeDate.day, props.shows]);

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    // Get the current hour
        //let day = currentDate.getDate();

       //let month = currentDate.getMonth() + 1;
       //let year = currentDate.getFullYear();
       let day = props.activeDate.day;

       let month = props.activeDate.month;
       let year = props.activeDate.year;
       if(props.activeDate.day==null){
        day = currentDate.getDate();
        month = currentDate.getMonth() + 1;
        year = currentDate.getFullYear();
       }
   
    var dateSTring= "";
    dateSTring = dateSTring+year;
    if(month<10){
        dateSTring=dateSTring+"0"+month;
    }else{
        dateSTring = dateSTring+month;
    }
    if(day<10){
        dateSTring=dateSTring+"0"+day;
    }else{
        dateSTring = dateSTring+day;
    }
    
    
    console.log("dateSTring");

    console.log(dateSTring);
    
 
    var firstINdex = props.shows.findIndex((show)=>{ 
              
        return show.date == dateSTring;

      });

    

    function getlistDayShows(){

        var testInt = 0;
        var listOfDateshows = props.shows.map((ele,index)=>{
        console.log("dateString is "+dateSTring)
        if(ele.date==dateSTring){
          testInt++;
            return (<Show show={ele} selectedDay={day} selectedMonth={month} key={index+6} handleShowClick={handleShowClick} showIndex={index}/>)
        }
        });
        console.log(testInt)
        if(testInt==0){
          setMessage("Schedule not available for this date, please check back later.")
        }else{
          setMessage("");
        }
        
        return listOfDateshows;
    };
    
    //var listDayShows = getlistDayShows();
   /*   
      useEffect(()=>{
       
         console.log(listDayShows);
      },[props.activeDate.day])
  
    
     */

    function handleShowClick(showKey){
        console.log(showKey);
        setSelectedShow(props.shows[showKey]);
       // selectedShowForFullDay.current.scrollIntoView({ behavior: 'instant', block: 'start' });
       setShowPopup(!showPopup);
      }

      const togglePopup = () => {
        setShowPopup(!showPopup);
      };
    

      
    useEffect(()=>{
      console.log("FIRST CALL");
      setListDayShows(getlistDayShows());
    },[]);
    return(
        <div id="fullDayScheduleContainer">
          <h1>Full Day CHCH Schedule</h1>
       
            <Popup show={showPopup}  selectedShow={selectedShow} onClose={togglePopup} blackoutData={props.blackoutData}>
      
            </Popup>


        <h4 id="fullDayScheduleDateHolder">{months[(month-1)] + " " + day   + " " + year}</h4>

              <h2>{message}</h2>
            <div ref={selectedShowForFullDay} id="selectedShow">
           
            </div>
        <div  className="ShowsContainer" id="FullDayShowContainer">
           
        {listDayShows}
        </div>
        </div>
        );
}
export default FullDaySchedule;